import { UrlSegment } from '@angular/router';

export function createLanguageMatcher(
  routes: { [key: string]: string },
  extraPaths?: { [lang: string]: string }
) {
  const paths = new Set([
    ...Object.keys(routes),
    ...Object.values(routes),
    ...Object.values(extraPaths ?? {}),
  ]);

  return function languageMatcher(
    url: UrlSegment[]
  ): { consumed: UrlSegment[] } | null {
    if (!url.length) return null;

    if (paths.has(url[0].path)) {
      return { consumed: [url[0]] };
    }

    return null;
  };
}
